import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';

function initSwiper(element) {
  const fractionElement = element.querySelector('.promotions-slider__fraction');

  new Swiper(element, {
    modules: [Navigation, Pagination, EffectFade, Autoplay],
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    runCallbacksOnInit: true,
    on: {
      init: (swiper) => {
        if (swiper.slides.length === 1) {
          fractionElement.hidden = true;
        }
      },
      slideChange: (swiper) => {
        if (fractionElement) {
          fractionElement.textContent = `${swiper.realIndex + 1}/${swiper.slides.length}`;
        }
      },
      autoplayTimeLeft: (swiper, timeLeft, percentage) => {
        const bullets = swiper.pagination.bullets;
        bullets.forEach((bullet, index) => {
          if (index < swiper.realIndex) {
            bullet.style.setProperty('--progress', '100%');
          } else if (index > swiper.realIndex) {
            bullet.style.setProperty('--progress', '0%');
          }
        });

        const currentBullet = bullets[swiper.realIndex];
        currentBullet.style.setProperty('--progress', `${100 - percentage * 100}%`);
      },
    },
  });
}

export function promotionsSlider() {
  const swiperElements = document.querySelectorAll('.promotions-slider .swiper');
  swiperElements.forEach((element) => initSwiper(element));
}
